<template>
  <div class="chat-page">
    <div class="chat-header">
      <span class="chat-title">消息</span>
      <div class="operate-btns">
        <button @click="closeChat" class="close-btn">
          <img src="../../assets/images/icon/close-icon.png" />
        </button>
      </div>
    </div>
    <ChatWindow
      :messages="messages"
      :input="input"
      @send="handleSend"
      @input-change="handleInputChange"
      :readonly="false"
      :tab-list="tabList"
      :active-tab="activeTab"
      :on-tab-click="handleTabClick"
      :userInfo="userInfo"
      :groupSessionId="groupSessionId"
      :selectedMember="selectedMember"
      @select-member="handleSelectMember"
      @load-more-messages="handleLoadMoreMessages"
      @only-show-teacher="handleOnlyShowTeacher"
      @forbid-click="handleForbidClick"
      @select-conversation="handleSelectConversation"
      @private-back="handlePrivateBack"
      @resendMessage="handleResendMessage"
    />
  </div>
</template>

<script>
import ChatWindow from "./ChatWindow.vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import chatMixin from "./mixins/chatMixin";

export default {
  name: "ChatPage",
  components: { ChatWindow },
  mixins: [chatMixin],
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
